import { Link } from 'react-router-dom';

export default function ServiziSection() {
  const servizi = [
    {
      icon: 'ri-search-line',
      title: 'Pre-Analisi Gratuita',
      description: 'Valutazione preliminare del potenziale di valorizzazione del tuo patrimonio aziendale',
      link: '/servizi',
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Perizia di Stima',
      description: 'Valutazione certificata del brand e degli asset intangibili secondo standard ISO 10668',
      link: '/servizi',
    },
    {
      icon: 'ri-team-line',
      title: 'Governance Strategica',
      description: 'Supporto nella gestione e protezione del patrimonio intangibile aziendale',
      link: '/servizi',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Metodo BCI',
      description: 'Metodologia proprietaria per la valorizzazione integrata del capitale aziendale',
      link: '/bci',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-gradient-to-b from-[#F8F9FA] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6">
            I Nostri Servizi
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto leading-relaxed px-4">
            Soluzioni complete per valorizzare il patrimonio della tua azienda
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {servizi.map((servizio, index) => (
            <Link
              key={index}
              to={servizio.link}
              className="bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 mb-4 sm:mb-6 flex items-center justify-center bg-[#22C55E]/10 rounded-lg group-hover:bg-[#22C55E]/20 transition-colors">
                <i className={`${servizio.icon} text-4xl sm:text-5xl text-[#22C55E]`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-3 sm:mb-4 group-hover:text-[#E879F9] transition-colors">
                {servizio.title}
              </h3>
              <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed mb-4 sm:mb-6">
                {servizio.description}
              </p>
              <div className="flex items-center text-[#E879F9] font-semibold text-sm sm:text-base group-hover:gap-3 transition-all">
                <span>Scopri di più</span>
                <i className="ri-arrow-right-line ml-2 group-hover:ml-0 transition-all"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16 lg:mt-20">
          <Link
            to="/servizi"
            className="inline-block px-8 sm:px-10 py-3 sm:py-4 bg-[#0B1F3B] text-white rounded-md text-base sm:text-lg font-semibold hover:bg-[#0B1F3B]/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Tutti i Servizi
          </Link>
        </div>
      </div>
    </section>
  );
}
